window.Page = {

    lightboxButton : document.querySelector('.property-gallery-label'),
    lightboxNext   : document.querySelector('.property-lightbox-next'),
    lightboxPrev   : document.querySelector('.property-lightbox-prev'),
    lightboxClose  : document.querySelector('.property-lightbox-close'),
    lightbox       : document.querySelector('.property-lightbox'),
    lightboxActive : document.querySelector('.property-lightbox-image-active'),

    // Let's launch this thing
    liftoff : () => {
        Page.initLightbox()
    },

    // My new function block
    initLightbox : () => {
        
        if (!Page.lightbox) return;

        Page.lightboxButton.addEventListener('click' , () => {
            Page.lightbox.classList.add('property-lightbox-active')
        })

        Page.lightboxClose.addEventListener('click' , () => {
            Page.lightbox.classList.remove('property-lightbox-active')
        })

        Page.lightboxNext.addEventListener('click' , () => {
            Page.lightboxActive.classList.remove('property-lightbox-image-active')
            Page.lightboxActive = Page.lightboxActive.nextElementSibling ?? Page.lightboxActive.parentElement.firstElementChild
            Page.lightboxActive.classList.add('property-lightbox-image-active')
        })

        Page.lightboxPrev.addEventListener('click' , () => {
            Page.lightboxActive.classList.remove('property-lightbox-image-active')
            Page.lightboxActive = Page.lightboxActive.previousElementSibling ?? Page.lightboxActive.parentElement.lastElementChild
            Page.lightboxActive.classList.add('property-lightbox-image-active')
        })

        

    }

};

Page.liftoff()